import React from "react";
import Restaurant from "./component/Basics/Restaurant";

const App = () => {
  // return <div>hello world</div>;
  return <Restaurant />;
};

//something

export default App;
